import { defineEvent } from "../types/event";
export var QUICKVIEW_PDP_BREADCRUMB_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_to_PDP_from_QuickView'
        }
    ]
});
